
interface Station {
  id: number;
  name: string;
  frequency: string;
  city: string;
  region: string;
  logo: string;
}

export default function RadioStations() {
  const stations: Station[] = [
    {
      id: 1,
      name: 'RADIO 2050 Madrid',
      frequency: '95.8 FM',
      city: 'Madrid',
      region: 'Comunidad de Madrid',
      logo: 'ri-radio-fill'
    },
    {
      id: 2,
      name: 'RADIO 2050 Barcelona',
      frequency: '98.3 FM',
      city: 'Barcelona',
      region: 'Cataluña',
      logo: 'ri-radio-fill'
    },
    {
      id: 3,
      name: 'RADIO 2050 Valencia',
      frequency: '101.5 FM',
      city: 'Valencia',
      region: 'Comunidad Valenciana',
      logo: 'ri-radio-fill'
    },
    {
      id: 4,
      name: 'RADIO 2050 Sevilla',
      frequency: '97.2 FM',
      city: 'Sevilla',
      region: 'Andalucía',
      logo: 'ri-radio-fill'
    },
    {
      id: 5,
      name: 'RADIO 2050 Bilbao',
      frequency: '99.7 FM',
      city: 'Bilbao',
      region: 'País Vasco',
      logo: 'ri-radio-fill'
    },
    {
      id: 6,
      name: 'RADIO 2050 Zaragoza',
      frequency: '96.4 FM',
      city: 'Zaragoza',
      region: 'Aragón',
      logo: 'ri-radio-fill'
    },
    {
      id: 7,
      name: 'RADIO 2050 Málaga',
      frequency: '100.1 FM',
      city: 'Málaga',
      region: 'Andalucía',
      logo: 'ri-radio-fill'
    },
    {
      id: 8,
      name: 'RADIO 2050 Murcia',
      frequency: '94.6 FM',
      city: 'Murcia',
      region: 'Región de Murcia',
      logo: 'ri-radio-fill'
    },
    {
      id: 9,
      name: 'RADIO 2050 Palma',
      frequency: '102.3 FM',
      city: 'Palma de Mallorca',
      region: 'Islas Baleares',
      logo: 'ri-radio-fill'
    },
    {
      id: 10,
      name: 'RADIO 2050 Las Palmas',
      frequency: '93.8 FM',
      city: 'Las Palmas',
      region: 'Islas Canarias',
      logo: 'ri-radio-fill'
    },
    {
      id: 11,
      name: 'RADIO 2050 Valladolid',
      frequency: '97.9 FM',
      city: 'Valladolid',
      region: 'Castilla y León',
      logo: 'ri-radio-fill'
    },
    {
      id: 12,
      name: 'RADIO 2050 Vigo',
      frequency: '95.2 FM',
      city: 'Vigo',
      region: 'Galicia',
      logo: 'ri-radio-fill'
    }
  ];

  const handlePlayOnline = () => {
    // Abrir el reproductor SSL en una nueva ventana
    window.open('https://srv7031.dns-lcinternet.com:7008', '_blank');
  };

  return (
    <div className="bg-gradient-to-br from-purple-800/50 to-blue-800/50 backdrop-blur-sm rounded-3xl p-8 shadow-2xl border border-white/10">
      <div className="flex items-center gap-3 mb-8">
        <div className="w-12 h-12 bg-gradient-to-br from-yellow-400 to-pink-500 rounded-full flex items-center justify-center">
          <i className="ri-broadcast-line text-2xl text-white"></i>
        </div>
        <div>
          <h3 className="text-2xl font-bold text-white">Dónde Escucharnos</h3>
          <p className="text-gray-300">Emisoras en toda España</p>
        </div>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {stations.map((station) => (
          <div 
            key={station.id}
            className="bg-white/10 backdrop-blur-sm rounded-2xl p-5 hover:bg-white/15 transition-all border border-white/5 hover:border-pink-500/30 cursor-pointer group"
          >
            <div className="flex items-start gap-4">
              <div className="w-14 h-14 bg-gradient-to-br from-pink-500 to-red-500 rounded-full flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                <i className={`${station.logo} text-2xl text-white`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-white font-bold text-lg mb-1 truncate">{station.name}</h4>
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-3 py-1 bg-gradient-to-r from-yellow-400 to-pink-500 text-white text-sm rounded-full font-bold">
                    {station.frequency}
                  </span>
                </div>
                <div className="text-gray-300 text-sm">
                  <div className="flex items-center gap-1 mb-1">
                    <i className="ri-map-pin-line text-pink-400"></i>
                    <span>{station.city}</span>
                  </div>
                  <div className="text-gray-400 text-xs">{station.region}</div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-8 text-center">
        <p className="text-gray-300 mb-4">
          <i className="ri-global-line text-pink-400 mr-2"></i>
          También disponible en streaming online en todo el mundo
        </p>
        <button 
          onClick={handlePlayOnline}
          className="px-6 py-3 bg-gradient-to-r from-pink-500 to-red-500 text-white rounded-full font-semibold hover:shadow-lg transition-all whitespace-nowrap cursor-pointer"
        >
          <i className="ri-play-circle-fill mr-2"></i>
          Escuchar Online
        </button>
      </div>
    </div>
  );
}
